import { render, staticRenderFns } from "./QuotationMessageModal.vue?vue&type=template&id=0fb04574&scoped=true&"
import script from "./QuotationMessageModal.vue?vue&type=script&lang=js&"
export * from "./QuotationMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb04574",
  null
  
)

export default component.exports